import { render, staticRenderFns } from "./brandActivity.vue?vue&type=template&id=4f0a762f&scoped=true"
import script from "./brandActivity.vue?vue&type=script&lang=js"
export * from "./brandActivity.vue?vue&type=script&lang=js"
import style0 from "./brandActivity.vue?vue&type=style&index=0&id=4f0a762f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0a762f",
  null
  
)

export default component.exports